export default function getResource(label, vars = []) {
    const resources = {
        cancel: 'Annuler',
        createdOn: 'créé le',
        edit: 'Modifier',
        orDevicePassword: 'ou le mot de passe de l’appareil.',
        passkey: 'Clé d’accès',
        remove: 'Retirer',
        signInWithFaceFingerprintPin: 'Ouvrez une session à l’aide de la reconnaissance faciale, de l’empreinte digitale ou du NIP.',
        signInWithFaceOrFingerprint: 'Ouvrez une session à l’aide de la reconnaissance faciale ou l’empreinte digitale.',
        sephoraAppText: '(Appli Sephora)',
        noPasskey: 'Aucune clé d’accès n’a été créée',
        createPasskey: 'Créer une clé d’accès',
        activePasskeys: `Vous avez *${vars[0]} clé(s) d’accès active(s)*`,
        create: 'Créer',
        browser: '(Navigateur)',
        thisDevice: 'Cet appareil'

    };
    return resources[label];
}
